// extracted by mini-css-extract-plugin
export default {"postList":"postList_postList__ZkKZ1"};